import { CAPTURED_ERROR_PREFACE } from './capture-error-in-sentry-with-custom-message';

export const IGNORED_SENTRY_ERRORS: (string | RegExp)[] = [
  // The error occurred component will in many cases be logging a duplicate
  // of an error we already logged. We don't want to double-report these to Sentry,
  // so should ignore the ones coming from the error occurred component.
  /ErrorOccurredComponent errorReason/,
  '[LaunchDarkly] Error on stream connection: {"isTrusted":true}',
  '[LaunchDarkly] The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied.',
  'LogRocket: insertRule/deleteRule rate limit exceeded',
  'Failed to match page route in useGetCurrentPage. Current pathname is: /ce-internal/flags',
  // Amplitude Replay logger warns a *lot* about stuff we don't care about:
  /Amplitude Logger \[Warn\]:/,
  'Amplitude Logger [Error]: Failed to fetch',
  'Amplitude Logger [Error]: Load failed',
  'Amplitude Logger [Error]: Event rejected due to exceeded retry count',
  // ${CAPTURED_ERROR_PREFACE} prefixes errors that we already reported to Sentry a different way,
  // so we should ignore them to avoid double-reporting:
  new RegExp(CAPTURED_ERROR_PREFACE),
  // This is from a crawler or something similar; it doesn't correspond to problems we care about:
  /wptagent/,
];
